import { render, staticRenderFns } from "./CorbeilleDetailModal.vue?vue&type=template&id=2cfed100"
import script from "./CorbeilleDetailModal.vue?vue&type=script&lang=ts"
export * from "./CorbeilleDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports